export default "__VITE_ASSET__DWLqGxLq__"